import { useEffect } from 'react';

import { Box, FullScreenLoader } from '@opendoor/bricks/core';

import { useAppDispatch } from 'src/store/hooks';
import { submitAndGoToNextPage } from 'src/store/ui';

const ExclusivesDelay = () => {
  const appDispatch = useAppDispatch();

  useEffect(() => {
    const handleSubmit = () => {
      appDispatch(submitAndGoToNextPage());
    };

    const timer = setTimeout(handleSubmit, 4000);

    return () => clearTimeout(timer);
  }, [appDispatch]);

  return (
    <Box height="100vh" width="100%">
      <FullScreenLoader />
    </Box>
  );
};

export default ExclusivesDelay;
